import PropTypes from 'prop-types'
import React, { Component } from 'react'

import { CaretBottomIcon } from 'components/Utils/Icons'
import Dropdown from 'components/base/Dropdown'
import { Name } from 'components/base/Text'
import { PenIcon, EyeIcon } from 'components/Utils/Icons'

const icons = {
  read: EyeIcon,
  edit: PenIcon,
}
export default class SelectLinkSharingOption extends Component {
  static propTypes = {
    currentPublicSharingOption: PropTypes.any.isRequired,
    onSelectPublicSharingOption: PropTypes.func.isRequired,
    publicSharingOptions: PropTypes.objectOf(
      PropTypes.shape({
        title: PropTypes.string.isRequired,
        inlineText: PropTypes.string.isRequired,
        description: PropTypes.string.isRequired,
      })
    ).isRequired,
    popoverPlacement: PropTypes.string.isRequired,
  }
  static defaultProps = {
    popoverPlacement: 'bottom-left',
  }

  render() {
    const {
      publicSharingOptions,
      currentPublicSharingOption,
      onSelectPublicSharingOption,
      popoverPlacement,
    } = this.props
    const CurrentSharingOptionIcon = icons[currentPublicSharingOption]
    return (
      <div onClick={e => e.stopPropagation()}>
        <Dropdown
          itemToString={item => (item ? item.title : '')}
          onSelect={onSelectPublicSharingOption}
        >
          {({
            getRootProps,
            getButtonProps,
            getItemProps,
            highlightedIndex,
            isOpen,
          }) => (
            <Dropdown.Wrapper {...getRootProps({ refKey: 'innerRef' })}>
              <div
                style={{ minWidth: 120 }}
                className="text-align-left shade-20 margin-left-smaller"
                {...getButtonProps()}
              >
                <div className="flexbox flexbox-space-between width-full primary primary-light-on-hover transition">
                  <div className="flexbox-grow font-weight-medium">
                    <CurrentSharingOptionIcon
                      size={12}
                      className="margin-horizontal-smaller"
                    />
                    {
                      publicSharingOptions[currentPublicSharingOption]
                        .inlineText
                    }
                  </div>
                  <div className="flexbox-no-grow">
                    <CaretBottomIcon
                      size={16}
                      style={{ verticalAlign: 'bottom' }}
                    />
                  </div>
                </div>
              </div>
              {isOpen && (
                <Dropdown.Body placement={popoverPlacement}>
                  {Object.keys(publicSharingOptions).map((key, index) => {
                    const publicSharingOption = publicSharingOptions[key]
                    const SharingOptionIcon = icons[key]
                    return (
                      <Dropdown.Item
                        selected={highlightedIndex === index}
                        key={key}
                        className="padding-vertical-medium transition"
                        style={{ lineHeight: 'inherit' }}
                        {...getItemProps({ item: key, index })}
                        icon={<SharingOptionIcon size={16} />}
                      >
                        <Name>{publicSharingOption.title}</Name>
                        <div className="shade-10 font-weight-regular">
                          {publicSharingOption.description}
                        </div>
                      </Dropdown.Item>
                    )
                  })}
                </Dropdown.Body>
              )}
            </Dropdown.Wrapper>
          )}
        </Dropdown>
      </div>
    )
  }
}
